import * as z from "zod";
import { dropPersonalConnectorUsages } from "../connectorUsages";
import { PERSONAL_USE_POLICIES } from "../personalUse";
import { mutator } from "./mutator";

export const setConnectedAppPersonalUse = mutator({
  schema: z.object({
    connectedAppId: z.string(),
    personalUse: z.enum(PERSONAL_USE_POLICIES),
  }),
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:share",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app, personalUse } }) => {
    if (app.personalUse === personalUse) return;
    await tx.mutate.connectedApps.update({ id: app.id, personalUse });
    if (personalUse === "disabled") {
      await dropPersonalConnectorUsages(tx, app.id);
    }
  },
});
